import { PropsWithChildren, useState } from "react"

import { Button, SxProps, Theme } from "@mui/material"
import { useTranslation } from "react-i18next"

import { LinkButtonHybrid, BaseModal } from "@/components"

interface ReadMoreButtonProps {
  modalHeadline: string
  buttonLabel: string

  sx?: SxProps<Theme>
}

const ReadMoreButton = ({
  buttonLabel,
  modalHeadline,
  sx,
  children,
}: PropsWithChildren<ReadMoreButtonProps>) => {
  const { t } = useTranslation()
  const [readMoreOpen, setReadMoreOpen] = useState(false)
  return (
    <>
      <LinkButtonHybrid
        color="textPrimary"
        onClick={() => setReadMoreOpen(true)}
        sx={sx}
      >
        {buttonLabel}
      </LinkButtonHybrid>
      <BaseModal
        open={readMoreOpen}
        onClose={() => setReadMoreOpen(false)}
        maxWidth={"sm"}
        title={modalHeadline}
        footerContent={
          <Button variant="contained" onClick={() => setReadMoreOpen(false)}>
            {t("passHolderDetails.form.closeButtonLabel")}
          </Button>
        }
      >
        {children}
      </BaseModal>
    </>
  )
}

export default ReadMoreButton
